import { render, staticRenderFns } from "./dialogPwd.vue?vue&type=template&id=2a554746"
import script from "./dialogPwd.vue?vue&type=script&lang=js"
export * from "./dialogPwd.vue?vue&type=script&lang=js"
import style0 from "./dialogPwd.vue?vue&type=style&index=0&id=2a554746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports